import { Outlet } from "react-router-dom";
import LandingLayoutHeader from "../components/headers/LandingLayoutHeader";

function LandingLayout () {
    return(
        <div>
            <LandingLayoutHeader />
            <Outlet />
        </div>
    )
    
}

export default LandingLayout;